import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import config from 'config';

const PrivateRoute = ({
  component: Component,
  isExact,
  isAuthSuccess,
  ...rest
}) => (
  <Route
    {...rest}
    exact={isExact}
    render={props =>
      isAuthSuccess === true ? (
        <Component {...props} {...rest} />
      ) : (
        <Redirect
          to={{
            pathname: config.defaultRedirectPublicRoute,
          }}
        />
      )
    }
  />
);

export default PrivateRoute;
